/* === ecommerce-tracking.js | Dawn 15.4 === */
(function () {
  // ---------- Helpers ----------
  function dl() { window.dataLayer = window.dataLayer || []; return window.dataLayer; }
  function getCurrency() {
    try { return (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'EUR'; }
    catch (_) { return 'EUR'; }
  }
  function toPrice(num) { return Number(num || 0) / 100; }

  // Cart.js → GA4 items mapper
  function mapCartToGA4Items(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];
    return cart.items.map(function (it) {
      return {
        item_id: String(it.variant_id || it.id),
        item_name: it.product_title || it.title || '',
        item_variant: it.variant_title || '',
        quantity: Number(it.quantity || 1),
        price: toPrice(it.price)
      };
    });
  }

  // /cart/add.js response → GA4 item
  function mapAddRespToGA4Item(data, qtyFallback) {
    var unitCents = Number((data && (data.final_price ?? data.price)) || 0);
    var qty = Number((data && data.quantity) || qtyFallback || 1);
    return {
      item_id: String((data && (data.variant_id ?? data.id)) || ''),
      item_name: (data && (data.product_title || data.title)) || '',
      item_variant: (data && data.variant_title) || '',
      quantity: qty,
      price: toPrice(unitCents)
    };
  }

  // Safe fetch JSON
  async function fetchCartJson() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return await res.json();
  }

  // Debounce for view_cart pushes
  var lastViewCartTs = 0;
  function shouldPushViewCart() {
    var now = Date.now();
    if (now - lastViewCartTs < 3000) return false;
    lastViewCartTs = now;
    return true;
  }

// --- Fetch-Interceptor: add_to_cart (Fallback) + remove_from_cart (Diff) ---
(function setupFetchInterceptor(){
  if (window.__gtmFetchHookInstalled__) return;
  window.__gtmFetchHookInstalled__ = true;

  var _fetch = window.fetch;

  // Hilfen aus dem File wiederverwenden / nachbauen:
  function dl(){ window.dataLayer = window.dataLayer || []; return window.dataLayer; }
  function getCurrency(){ try { return (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'EUR'; } catch(_){ return 'EUR'; } }
  function toPrice(num){ return Number(num || 0) / 100; }

  function mapAddRespToGA4Item(data, qtyFallback){
    var unitCents = Number((data && (data.final_price ?? data.price)) || 0);
    var qty = Number((data && data.quantity) || qtyFallback || 1);
    return {
      item_id: String((data && (data.variant_id ?? data.id)) || ''),
      item_name: (data && (data.product_title || data.title)) || '',
      item_variant: (data && data.variant_title) || '',
      quantity: qty,
      price: toPrice(unitCents)
    };
  }

  function mapCartItems(cart){
    if (!cart || !Array.isArray(cart.items)) return [];
    return cart.items.map(function (it) {
      return {
        variant_id: Number(it.variant_id || it.id),
        title: it.product_title || it.title || '',
        variant_title: it.variant_title || '',
        quantity: Number(it.quantity || 0),
        price_cents: Number(it.price || 0)
      };
    });
  }

  function indexByVariant(items){
    var map = {};
    items.forEach(function (it){ map[String(it.variant_id)] = it; });
    return map;
  }

  async function fetchCartJson(){
    try {
      var res = await _fetch('/cart.js', { credentials: 'same-origin' });
      return await res.json();
    } catch(_){ return null; }
  }

  window.fetch = function(){
    try {
      var url = arguments[0];
      var init = arguments[1] || {};
      var urlStr = String(url || '');

      var isAdd = urlStr.indexOf('/cart/add') !== -1;
      var isChangeOrUpdate = (urlStr.indexOf('/cart/change') !== -1) || (urlStr.indexOf('/cart/update') !== -1);

      // Für remove_from_cart: Vorher-Snapshot holen, wenn wir eine Änderung erkennen
      var preCartPromise = null;
      if (isChangeOrUpdate) {
        preCartPromise = fetchCartJson();
      }

      return _fetch.apply(this, arguments).then(async function(res){
        try {
          // ---- add_to_cart (Fallback, wenn kein Pub/Sub läuft) ----
          if (isAdd) {
            try {
              var clone = res.clone();
              var isJson = /application\/json|\/json/i.test(clone.headers.get('content-type') || '') || urlStr.indexOf('.js') !== -1;
              if (isJson) {
                var data = await clone.json();
                var qty = 1;
                if (init && init.body) {
                  try {
                    var body = typeof init.body === 'string' ? JSON.parse(init.body) : init.body;
                    qty = Number(body.quantity || 1);
                  } catch(_){}
                }
                var item = mapAddRespToGA4Item(data, qty);
                if (item.item_id) {
                  dl().push({
                    event: 'add_to_cart',
                    ecommerce: { currency: getCurrency(), value: (item.price || 0) * item.quantity, items: [item] }
                  });
                }
              }
            } catch(_){}
          }

          // ---- remove_from_cart via Diff (preCart vs postCart) ----
          if (isChangeOrUpdate) {
            try {
              var preCart = await preCartPromise;                   // Zustand vor der Änderung
              var postCart = await fetchCartJson();                 // Zustand nach der Änderung
              if (preCart && postCart) {
                var preIdx = indexByVariant(mapCartItems(preCart));
                var postIdx = indexByVariant(mapCartItems(postCart));

                var removedItems = [];
                Object.keys(preIdx).forEach(function(vid){
                  var before = preIdx[vid];
                  var after  = postIdx[vid];
                  var beforeQty = Number(before.quantity || 0);
                  var afterQty  = Number((after && after.quantity) || 0);
                  var delta = beforeQty - afterQty;
                  if (delta > 0) {
                    removedItems.push({
                      item_id: String(vid),
                      item_name: before.title,
                      item_variant: before.variant_title || '',
                      quantity: delta,
                      price: toPrice(before.price_cents) // Preis pro Stück
                    });
                  }
                });

                if (removedItems.length) {
                  var totalValue = removedItems.reduce(function(sum, it){ return sum + (Number(it.price || 0) * Number(it.quantity || 0)); }, 0);
                  dl().push({
                    event: 'remove_from_cart',
                    ecommerce: {
                      currency: getCurrency(),
                      value: totalValue,
                      items: removedItems
                    }
                  });
                }
              }
            } catch(_){}
          }
        } catch(_){}

        return res;
      });
    } catch(e){
      return _fetch.apply(this, arguments);
    }
  };
})();


  // ---------- view_cart ----------
  async function pushViewCart() {
    if (!shouldPushViewCart()) return;
    try {
      var cart = await fetchCartJson();
      dl().push({
        event: 'view_cart',
        ecommerce: {
          currency: getCurrency(),
          value: toPrice(cart.total_price),
          items: mapCartToGA4Items(cart)
        }
      });
    } catch (e) { /* noop */ }
  }

  // /cart (Seite)
  try {
    var cleanPath = location.pathname.replace(/\/+$/, '');
    if (cleanPath === '/cart') {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', pushViewCart);
      } else {
        pushViewCart();
      }
    }
  } catch (_) {}

  // Cart Drawer öffnen → view_cart
  (function hookCartDrawerOpens() {
    var SELECTORS = [
      '[aria-controls="CartDrawer"]',
      'a[href="#cart-drawer"]',
      'button[name="open-drawer"][data-drawer-id="cart-drawer"]',
      'cart-icon-bubble a',
      'cart-icon-bubble button'
    ].join(',');
    document.addEventListener('click', function (evt) {
      var el = evt.target && evt.target.closest && evt.target.closest(SELECTORS);
      if (!el) return;
      setTimeout(pushViewCart, 120);
    }, true);

    // Falls programmatisch geöffnet → via MutationObserver absichern
    var drawerEl = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
    if (drawerEl && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () { pushViewCart(); });
      mo.observe(drawerEl, { attributes: true, attributeFilter: ['open', 'class', 'style'] });
    }
  })();

  // ---------- begin_checkout ----------
  async function pushBeginCheckout() {
    try {
      var cart = await fetchCartJson();
      dl().push({
        event: 'begin_checkout',
        ecommerce: {
          currency: getCurrency(),
          value: toPrice(cart.total_price),
          items: mapCartToGA4Items(cart)
        }
      });
    } catch (e) { /* noop */ }
  }
  document.addEventListener('click', function (evt) {
    var el = evt.target && evt.target.closest && evt.target.closest('[name="checkout"], button.checkout, a.checkout, .cart__checkout-button');
    if (!el) return;
    pushBeginCheckout();
  }, true);

  // ---------- view_item (Produktseite) ----------
  function pushViewItemIfProduct() {
    try {
      // Erkennung: Produktseite, Daten aus JSON-Script ziehen
      var productScript =
        document.querySelector('script[type="application/json"][data-product]') ||
        document.querySelector('product-form script[type="application/json"]') ||
        document.querySelector('script[type="application/json"][id*="ProductJson"]');

      if (!productScript) return;

      var json;
      try { json = JSON.parse(productScript.textContent || '{}'); } catch(_) { json = null; }
      if (!json) return;

      // Variant-ID ermitteln
      var variantId = null;
      // 1) URL ?variant=...
      var m = location.search.match(/[?&]variant=(\d+)/);
      if (m) variantId = m[1];
      // 2) falls nicht: ausgewählte Variante in JSON
      if (!variantId && json && json.selected_or_first_available_variant && json.selected_or_first_available_variant.id) {
        variantId = json.selected_or_first_available_variant.id;
      }
      // 3) falls nicht: erste Variante
      if (!variantId && Array.isArray(json.variants) && json.variants[0] && json.variants[0].id) {
        variantId = json.variants[0].id;
      }

      var item = {
        item_id: String(variantId || json.id || ''),
        item_name: (json.title || document.title || '').trim(),
        item_variant: '',
        quantity: 1,
        price: (json && json.price) ? toPrice(json.price) : undefined
      };

      dl().push({
        event: 'view_item',
        ecommerce: {
          currency: getCurrency(),
          value: item.price || undefined,
          items: [item]
        }
      });
    } catch (e) { /* noop */ }
  }
  // nur ausführen, wenn Produkt-Form existiert
  if (document.querySelector('product-form')) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', pushViewItemIfProduct);
    } else {
      pushViewItemIfProduct();
    }
  }
})();
